const paddings = {
  xs: '0.5rem', // 8px
  sm: '0.9375rem', // 15px
  md: '1.875rem', // 30px
  lg: '3.75rem', // 60px
  xl: '5.625rem' // 90px
};

export { paddings };
